module.exports = __webpack_public_path__ + "static/media/bookmarks.da6a5f9e.png";